import {
  DESTROY_USER_FLOW,
  SCREEN_FLOW,
  TIMELINE_FLOW,
  UPDATE_SCREEN_OBJECT,
  UPDATE_TIMELINE,
  USER_FLOW_JUMP_TO,
  USER_FLOW_NEXT,
  USER_FLOW_PREV,
  UPDATE_TIMELINE_CONFIG,
  USER_FLOW_JUMP_WITH_TIMELINE_CHANGE,
  CHANGE_SCREEN_CONFIG,
  DISABLE_PERSONAL_DETAILS_FILEDS,
  UPDATE_DOCUMENT_TIMELINE_CONFIG,
  ONLY_ACK_SCREEN,
  PRE_SELECT_PAYMENT_METHOD
} from '../../action-contants';
import { remitterPersonalInfo } from '../user-status/user-status-action';
import { activateLoader, disableLoader, scrollToTopAction } from '../ui-trigger/ui-trigger-action';
import { handleError } from '../common-message/message-action';
import {
  REGISTERED,
  INITIATED,
  ACKNOWLEDGED,
  SCREEN_NAME_SCHEDULE_INTERVIEW,
  SCREEN_NAME_PHOTO_UPLOAD,
  CORPORATE,
  INDIVIDUAL
} from '../../../utils/constants';
import { getScreensAndTimeline, isKYCSplitFlow } from '../../../utils/library';
import sortBy from 'lodash/sortBy';
import { API_URL } from '@Utils/config';
import { makeApiCall } from '../common';

export function destroyUserFlowAction() {
  return (dispatch) => {
    //update the screens
    dispatch({
      type: DESTROY_USER_FLOW
    });
    return {};
  };
}

export function updateScreenConfig(screen, status) {
  return (dispatch) =>
    //update the screens
    dispatch({
      type: UPDATE_SCREEN_OBJECT,
      data: {
        screen,
        status
      }
    });
}

function sortScreenData(data) {
  data.length > 1 && data.sort((a, b) => a.timeline_sequence - b.timeline_sequence);
  data.forEach((datum) => datum.screens.sort((s1, s2) => s1.sequence - s2.sequence));
  return data;
}

function extractSubScreens(screens, timeline_sequence, screen_name) {
  let contains = false,
    subs = screens.map(({ name, is_required, sequence }) => {
      if (!contains) contains = name === screen_name;
      return { name, is_required, timeline_sequence, sequence };
    });
  const newSubs = sortBy(subs, (obj) => obj.sequence);
  return {
    contains,
    subs: newSubs
  };
}

function addTimelineMetaConfig(data, instapointsLogic, instapoints) {
  const { initial_referral_instapoint, acknowledgement_instapoint } = instapointsLogic;
  data.forEach((item) => {
    if (item.key === 'sign_up') {
      item.timeline_meta = {
        heading: {
          text: `Earned ${instapoints} IPs`,
          show_info_icon: true,
          className: 'brand-blue-color heading',
          show_blinker: false
        },
        sub_heading: {
          show_timer: false,
          text: '(IPs: InstaPoints)',
          className: 'gray-text-color sub-heading'
        }
      };
    }
    if (item.key === 'personal') {
      item.timeline_meta = {
        heading: {
          text: `Referral Bonus`,
          show_info_icon: true,
          className: 'brand-blue-color referral-heading heading',
          show_blinker: false
        },
        sub_heading: {
          show_timer: false,
          show_info_icon: true,
          text: `${initial_referral_instapoint} IPs`,
          className: 'brand-green-color referral-sub-heading sub-heading'
        }
      };
    }
    if (item.key === 'acknowledgement') {
      item.timeline_meta = {
        heading: {
          text: `Get ${acknowledgement_instapoint} IPs`,
          show_info_icon: true,
          className: 'light-blue-color heading',
          show_blinker: true
        },
        sub_heading: {
          show_timer: true,
          text: '',
          className: 'gray-text-color sub-heading'
        }
      };
    }
  });
  return data;
}

function getScreensIfMobileVerified(isPhoneVerifierd, screens) {
  if (isPhoneVerifierd) {
    return [...screens].filter((obj) => obj.name !== 'mobile_verification');
  } else {
    return [...screens];
  }
}

export function changeScreenConfig(screens) {
  return {
    type: CHANGE_SCREEN_CONFIG,
    screens: sortBy(screens, (obj) => obj.timeline_sequence)
  };
}

function changeTimeLine(data) {
  return {
    type: TIMELINE_FLOW,
    data
  };
}
export function changeScreenTimelineForJumio(data, isKYC = null) {
  return (dispatch) => {
    let {
      screen_name,
      is_phone_verified,
      customer_type,
      account_type,
      is_permanent_sg_resident,
      status
    } = data.remitterDetails;
    const { country_code, oldTimeLine } = data;
    let { individual_on_boarding: screens_data } = data.remitterDetails;
    let { screens, timeLine } = getScreensAndTimeline(screens_data, screen_name, oldTimeLine);
    /**
     * check added for a particular scenario
     * F2F -> Mobile Not verified -> Sch. Intv.
     * Back from Sch. Intv. goes to upload screen
     * To avoid OTP screen again below check is made
     */
    let currentScreenIndex = 0;
    if (is_phone_verified) {
      screens.forEach((i, j) => {
        if (i.name === 'mobile_verification') {
          screens.splice(j, 1);
        }
      });
      if (!isKYC && country_code === 'MY') {
        screen_name = 'schedule_interview';
      }
    }
    // check ends here
    if (isKYC) {
      if (country_code === 'MY') {
        screens.forEach((i, j) => {
          if (i.name === 'schedule_interview') {
            screens.splice(j, 1);
          }
        });
        timeLine.forEach((i, j) => {
          if (i.label === 'Interview') {
            timeLine.splice(j, 1);
          }
        });
      }
      if (customer_type === 'CITIZEN' || ['SG', 'HK'].includes(country_code)) {
        if (
          country_code === 'HK' ||
          (country_code === 'SG' && status !== INITIATED && is_permanent_sg_resident)
        )
          screens.forEach((i, j) => {
            if (i.name === 'individual_documents_upload') {
              currentScreenIndex = j;
              screens.splice(j, 1);
            }
          });
        if (country_code === 'HK') {
          screens.forEach((i, j) => {
            if (i.name === 'individual_photo_upload') {
              currentScreenIndex = j;
              screens.splice(j, 1);
            }
          });
        }
        timeLine.forEach((i, j) => {
          if (i.label === 'Documents') {
            timeLine.splice(j, 1);
          }
        });
      }
      if (country_code === 'MY') {
        dispatch({
          type: DISABLE_PERSONAL_DETAILS_FILEDS
        });
      }
    }
    if (
      account_type === INDIVIDUAL &&
      country_code === 'SG' &&
      status === INITIATED &&
      !is_permanent_sg_resident
    ) {
      dispatch(changeScreen(USER_FLOW_JUMP_TO, 'individual_documents_upload', screens, timeLine));
      return;
    }

    if (country_code !== 'MY') {
      const screenObj = screens[currentScreenIndex - 1];
      screen_name = screenObj ? screenObj.name : screen_name;
      dispatch(changeScreen(USER_FLOW_NEXT, screen_name, screens, timeLine));
    }

    if (country_code === 'MY') {
      dispatch({
        type: SCREEN_FLOW,
        data: {
          screens,
          currentScreen: screen_name
        }
      });
      dispatch({
        type: TIMELINE_FLOW,
        data: timeLine
      });
    }
  };
}
export function changeTimeLineMY({ country_code, screens, timeLine, remitterDetails }) {
  return (dispatch, getState) => {
    const {
      rootReducer: {
        userStatusReducer: { is_phone_verified }
      }
    } = getState();
    const interviewTimeline = {
      key: undefined,
      label: 'Interview',
      status: 'pending',
      timeline_meta: undefined,
      timeline_sequence: 3
    };
    const sheduleInterviewScreenConfig = {
      is_required: true,
      name: 'schedule_interview',
      timeline_sequence: 3
    };

    if (country_code === 'MY') {
      // need to make sure that sheduleInterviewScreenConfig is pushed before ack screen
      const screensCpy = getScreensIfMobileVerified(is_phone_verified, screens);
      // hard coded  to 3 because at index3 ack comes, need to append sheduleInterviewScreenConfig before that
      screensCpy.splice(2, 0, sheduleInterviewScreenConfig);

      /**push interview in timeline*/
      const timelineCpy = [...timeLine];
      timelineCpy.splice(2, 0, interviewTimeline);

      /**push interview in screen_config & save as original screen config for 'MY' */
      const screens_prev = screens.find((obj) => obj.name === 'schedule_interview')
        ? screens
        : screensCpy;
      const timeline_prev = timeLine.find((obj) => obj.label === 'Interview')
        ? timeLine
        : timelineCpy;

      /**check and push selfieUpload in screens */
      const newScreens = screens.filter((obj) => obj.name !== SCREEN_NAME_SCHEDULE_INTERVIEW);
      // !newScreens.find(obj => obj.name === SCREEN_NAME_PHOTO_UPLOAD) && newScreens.splice(2, 0, selfieUpload)

      const newTimeline = timeLine.filter((obj) => obj.label !== 'Interview');

      if (remitterDetails.kyc_type === 'EKYC') {
        dispatch(changeScreenConfig(getScreensIfMobileVerified(is_phone_verified, newScreens)));
        dispatch(changeTimeLine(newTimeline));
      } else if (remitterDetails.kyc_type === 'F2F') {
        const newScreens = screens.filter((obj) => obj.name !== SCREEN_NAME_PHOTO_UPLOAD);
        newScreens.splice(3, 0, sheduleInterviewScreenConfig);

        dispatch(changeScreenConfig(getScreensIfMobileVerified(is_phone_verified, newScreens)));
        dispatch(changeTimeLine(timeline_prev));
      } else {
        dispatch(changeScreenConfig(getScreensIfMobileVerified(is_phone_verified, screens_prev)));
        dispatch(changeTimeLine(timeline_prev));
      }
    }
  };
}

export function getInitialUserFlow(data, screen_name, optionsForReferral = null) {
  return (dispatch, getState) => {
    try {
      let state = getState().rootReducer;
      const {
        userStatusReducer: { status },
        userSessionReducer: {
          user_session: { account_type },
          instapoint_balance: { instapoints }
        }
      } = state;
      let instapointsLogic = state.userDataReducer.instaPointsLogicData;
      let { status: userStatus, country_code } = state.userStatusReducer;
      const {
        userDataReducer: {
          userStateInfo: { remitterDetails }
        }
      } = state;
      const isNewOnboardingFlow = isKYCSplitFlow(country_code, userStatus, true, account_type);
      if (
        instapointsLogic &&
        userStatus &&
        [REGISTERED, INITIATED, ACKNOWLEDGED].includes(userStatus) &&
        !isNewOnboardingFlow &&
        country_code !== 'MY'
      ) {
        if (optionsForReferral && optionsForReferral.isIndividualUser) {
          data = [
            {
              label: 'Sign Up',
              screens: [],
              timeline_sequence: -1
            },
            ...data
          ];
        }
        //add unique identifier 'key' in the data : To make the key slugify
        data.forEach((x) => (x.key = x.label.replace(/[ ]/g, '_').toLowerCase()));

        //add meta config for instapoints logic
        data = addTimelineMetaConfig(data, instapointsLogic, instapoints);
      }

      //sort the screens according to their sequence no
      sortScreenData(data);

      //tracks the screen that is in processing
      let currentUserIndex = 0,
        isValidScreen = false,
        //compiles the timeline and screen, sub screens are flattened
        { screens, timeLine } = data.reduce(
          (acc, { label, timeline_sequence, screens, timeline_meta, key }, index) => {
            acc.timeLine.push({
              label,
              timeline_sequence,
              status: timeline_sequence < 0 ? 'completed' : 'pending',
              timeline_meta,
              key
            });

            //flattens the sub screen and also infers if the user had left at this timeline sequence
            let { subs, contains } = extractSubScreens(screens, timeline_sequence, screen_name);
            acc.screens = acc.screens.concat(subs);

            //if the user left at this timeline, we restore that index
            if (contains) {
              currentUserIndex = index;
              isValidScreen = true;
            }
            return acc;
          },
          { screens: [], timeLine: [] }
        );

      if (timeLine[currentUserIndex].timeline_sequence <= 0) {
        timeLine[currentUserIndex].status = 'completed';
        currentUserIndex = 1;
      }

      //all previous timelines are marked completed
      if (isValidScreen)
        for (let i = 0, iL = currentUserIndex; i < iL; i++) timeLine[i].status = 'completed';

      //successfully restored client's timeline index
      timeLine[currentUserIndex].status = 'processing';
      dispatch({
        type: SCREEN_FLOW,
        data: {
          screens,
          currentScreen: screen_name && isValidScreen ? screen_name : screens[0].name
        }
      });

      /**if phone is verified and type===kyc then remove schedule_interview from screen config */
      if (
        country_code === 'MY' &&
        account_type !== CORPORATE &&
        (status === INITIATED || status === REGISTERED)
      ) {
        dispatch(changeTimeLineMY({ country_code, screens, timeLine, remitterDetails }));
      } else {
        dispatch({
          type: TIMELINE_FLOW,
          data: timeLine
        });
      }
    } catch (err) {
      dispatch(handleError(err));
    }
  };
}

export function findRequiredScreen(fromIndex, order, screens) {
  let i = fromIndex;
  if (order.toLowerCase() === 'forward') {
    //keep going forward until we find a screen that is required
    while (++i < screens.length) if (screens[i].is_required) return screens[i];
  } else if (order.toLowerCase() === 'backward') {
    //keep going backward until we find a screen that is required
    while (--i > -1) if (screens[i].is_required) return screens[i];
  }

  //return this screen itself as default
  return screens[fromIndex];
}

function getReqIndex(screenName, newScreenObj, timeLine, country_code) {
  // add check for nationality ==='MY' and country-code==='MY'
  if (screenName === 'mobile_verification' && timeLine.length === 2 && country_code === 'MY') {
    return 1;
  } else {
    return newScreenObj.timeline_sequence - 1;
  }
}
export function changeScreen(
  type,
  screenName,
  screens,
  timeline,
  eghlUrl,
  isBeneAdditionalInfoScreen
) {
  let isSignedUpTimeline = timeline.findIndex((x) => x.key === 'sign_up') > -1;
  return async (dispatch, getState) => {
    const {
      rootReducer: {
        userStatusReducer: { status, country_code }
      }
    } = getState();
    if (!screens || !timeline || !screenName) return;
    try {
      let newScreenName = screenName;
      let newScreenObj = null;
      //finds the index of current index
      let current = screens.findIndex(({ name }) => name === screenName);
      switch (type) {
        case USER_FLOW_PREV:
          if (current !== 0) {
            newScreenObj = findRequiredScreen(current, 'backward', screens);
            newScreenName = newScreenObj.name;
            if (newScreenObj.timeline_sequence) {
              let reqIndex = newScreenObj.timeline_sequence - 1;
              if (isSignedUpTimeline) reqIndex++;
              //to maintain proper flow and not considering the Sign Up timeline section while changing the screens
              let timelineObj = timeline[reqIndex];
              /**
               * Changes by Krunal - 04/05/20
               * For making backed screen as processing and other screens as pending
               */
              for (let i = 0; i < timeline.length - 1; i++) timeline[i].status = 'pending';
              /** Till here */
              if (timelineObj && timelineObj.timeline_sequence > 0) {
                timelineObj.status = 'processing';
              }
            }
          }
          break;

        case USER_FLOW_NEXT:
          if (current < screens.length - 1) {
            newScreenObj = findRequiredScreen(current, 'forward', screens);
            newScreenName = newScreenObj.name;
            if (newScreenObj.timeline_sequence) {
              let reqIndex = getReqIndex(screenName, newScreenObj, timeline, country_code);
              if (isSignedUpTimeline) reqIndex++;
              //to maintain proper flow and not considering the Sign Up timeline section while changing the screens
              let timelineObj = timeline[reqIndex];
              for (let i = 0, iL = reqIndex; i < iL; i++) timeline[i].status = 'completed';
              if (timelineObj && timelineObj.timeline_sequence > 0) {
                timelineObj.status = 'processing';
              }
            }
          }
          break;

        case USER_FLOW_JUMP_TO:
          if (current !== -1 && screens[current].is_required) {
            let timelineObj = timeline[screens[current].timeline_sequence - 1];
            if (timelineObj?.timeline_sequence > 0 && status !== INITIATED)
              timelineObj.status = 'processing';
          }
          break;

        //Dangrous to set screens with this action only use above
        case USER_FLOW_JUMP_WITH_TIMELINE_CHANGE:
          break;
        default:
          return;
      }
      //take updated status for user
      //eghUrl check is given as it caused NINSTA-14982 issue in safari
      if (!eghlUrl && !isBeneAdditionalInfoScreen) {
        await dispatch(remitterPersonalInfo());
      }
      //update the screens
      dispatch({
        type,
        data: newScreenName
      });

      //update the timeline
      if (!(country_code === 'MY' && (status === INITIATED || status === REGISTERED))) {
        dispatch({
          type: UPDATE_TIMELINE,
          data: {
            timeline,
            currentScreen: newScreenName
          }
        });
        //scroll to top
        dispatch(scrollToTopAction());
      }
    } catch (err) {
      dispatch(handleError(err));
    }
  };
}

export function updateUserFlow(screens, timeline, screenName) {
  let currentIndex = screens.findIndex(({ name }) => name === screenName);
  let nextValidScreen = null;
  for (let i = currentIndex, iL = screens.length; i < iL; i++)
    if (screens[i].is_required) {
      nextValidScreen = screens[i].name;
      break;
    }
  return nextValidScreen && changeScreen(USER_FLOW_JUMP_TO, nextValidScreen, screens, timeline);
}

export function updateTimelineConfig(data) {
  return {
    type: UPDATE_TIMELINE_CONFIG,
    data
  };
}

export function updateDocumentTimelineConfig(data) {
  return {
    type: UPDATE_DOCUMENT_TIMELINE_CONFIG,
    data
  };
}

export function ackScreenShowOnce(data) {
  return {
    type: ONLY_ACK_SCREEN,
    data
  };
}

export const storePreSelectPaymentMethod = (data) => {
  return {
    type: PRE_SELECT_PAYMENT_METHOD,
    data
  };
};

export const storeUserConsent = ({ user_consent, brand }) => {
  return async (dispatch) => {
    const params = {
      url: `${API_URL}/remitter/consent`,
      method: 'post',
      data: {
        user_consent,
        brand
      }
    };
    dispatch(activateLoader());
    try {
      const response = await makeApiCall({ ...params, withCredentials: true });
      if (response.status === 200 && response.data && response.data.success) {
        dispatch(disableLoader());
      }
      dispatch(disableLoader());
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('user_consent error :', err);
      dispatch(disableLoader());
    }
  };
};
